import LoggerUtils from '../utils/LoggerUtils';

export default class AjaxUtils {

  static getHeaders() {
    let headers = {
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json',
    };
    return headers;
  }

  static getParamObjectFor(name, value) {
    return {name, value};
  }

  static setParameters(url, params) {
    const paramString = params.map(param => {
      return param.name + '=' + param.value;
    }).join('&');

    return url + '?' + paramString;
  }

  static checkResponseStatus(response) {
    LoggerUtils.debug('RESPONSE Status: ' + response.status);
    
    if (response.status < 200 || response.status >= 400) {
      throw 'An unexpected error has occurred!';
    }

    return response;
  }

}